import { connectedStore } from '../../store';
import constants from '../constants';
import view from '../../view';
import template from '../../template';

const { GLOBAL_STYLES_VARIABLE } = constants;

const getCustomGlobalStylesStylesheet = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);

  if (!variables[GLOBAL_STYLES_VARIABLE]) return null;

  const { id } = variables[GLOBAL_STYLES_VARIABLE][0];
  const liveDom = view.accessors.getLiveDocument();

  return (
    Array.from(liveDom.styleSheets).find((item) => item.ownerNode.parentElement.id === id) || null
  );
};

export default getCustomGlobalStylesStylesheet;
